import React from "react";
import {NavLink} from "react-router-dom";

function BillingNavTab() {

    return (
        <div className="col-md-3 col-lg-2 setting_sidebar">
            <div className="">
                <div className="nav nav-tab " id="nav-tab" role="tablist">
                    <NavLink to={'/billing'} className="nav-link mb-2 ps-3" end>
                        {/* <img src="/images/Billing_Overview.webp" alt="..." className="me-2 text-white"/> */}
                        Billing Overview
                    </NavLink>
                    <NavLink to={"/billing/history"} className="nav-link mb-2 ps-3">
                        {/* <img src="/images/Billing_History.webp" alt="..." className="me-2"/> */}
                        Billing History
                    </NavLink>
                    <NavLink to={"/billing/credit-history"} className="nav-link mb-2 ps-3">
                        {/* <img src="/images/Credit_History.png" alt="..." className="me-2"/> */}
                        Credit History
                    </NavLink>
                    <NavLink to={"/billing/pricing"} className="nav-link mb-2 ps-3">
                        {/* <img src="/images/Pricing_Plan.webp" alt="..." className="me-2"/> */}
                        Pricing Plan
                    </NavLink>
                </div>
            </div>
        </div>
    );
}

export default BillingNavTab;